// extracted by mini-css-extract-plugin
export default {"heading-space":"NewsletterPage_heading-space__Iy4vi","content-wrapper":"NewsletterPage_content-wrapper__tRP-1"};